/** Matching the editor's paragraph `tab-size`. */
const TAB_WIDTH_EM = 2;

// https://github.com/saadq/sanitize-latex/blob/master/index.js
const symbolMap: Record<string, string> = {
  "'": "\\textquotesingle{}",
  '"': "\\textquotedbl{}",
  "`": "\\textasciigrave{}",
  "^": "\\textasciicircum{}",
  "~": "\\textasciitilde{}",
  "<": "\\textless{}",
  ">": "\\textgreater{}",
  "|": "\\textbar{}",
  "\\": "\\textbackslash{}",
  "{": "\\{",
  "}": "\\}",
  $: "\\$",
  "&": "\\&",
  "#": "\\#",
  _: "\\_",
  "%": "\\%",
  "\t": `\\hspace{${TAB_WIDTH_EM}em}`,
};

const SYMBOL_REGEX = new RegExp(`[${Object.keys(symbolMap).join("").replace("\\", "\\\\")}]`, "g");

/** @param keepTabs Leaves tabs as they are, for text that `\verb` prints verbatim. */
export function sanitizeLatex(str: string, { keepTabs = false } = {}): string {
  return str.replace(SYMBOL_REGEX, (char: string) => {
    return keepTabs && char === "\t" ? char : symbolMap[char];
  });
}
